import { Button } from "design-react-kit";
import React, { Component } from "react";
import { ReactMediaRecorder } from "react-media-recorder";
import { FaMicrophoneAlt, FaStop, FaRedo, FaCheckCircle } from "react-icons/fa";
import i18n from "app/i18n";
import { adminService, networkErrorHelper } from "libs";

export class AnswerVoiceRecorder extends Component {
  state = {
    recorderKey: 0,
    countdown: 3,
    showStop: false,
    savedRecording: null,
    recordingTimeout: null,
    maxTimeRecorder: 120000, // 120 seconds max recording time ( 2 minutes )
    recordingSecondsRemaining: null,
  };

  countdownInterval = null;
  recordingInterval = null;

  componentDidMount() {
    const { idQuestion, idQuiz } = this.props;
    const saved = localStorage.getItem(`quiz-${idQuiz}-${idQuestion}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed[0].label) {
          this.setState({ savedRecording: parsed[0].label });
        }
      } catch (e) {
        console.error("Errore nel parsing del salvataggio", e);
      }
    }

    //--- ---
    if (!this.props.isEmptyLabel) {
      adminService
        .loadAudioAssetByOriginalName(this.props.answers[0].label)
        .then(({ data }) => {
          if (data.payload && data.payload.fullurl) {
            this.setState({ savedRecording: data.payload.fullurl });
          }
        })
        .catch((error) => {
          networkErrorHelper.notify(error);
          console.log(error);
        });
    }
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
    clearInterval(this.recordingInterval);
    if (this.state.recordingTimeout) clearTimeout(this.state.recordingTimeout);
  }

  resetRecording = () => {
    clearInterval(this.countdownInterval);
    clearTimeout(this.state.recordingTimeout);
    clearInterval(this.recordingInterval);

    this.setState((state) => ({
      recorderKey: state.recorderKey + 1,
      countdown: 3,
      showStop: false,
      recordingTimeout: null,
      recordingSecondsRemaining: null,
    }));
  };

  startCountdown = () => {
    this.setState({ countdown: 3, showStop: false });
    this.countdownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          clearInterval(this.countdownInterval);

          // auto stop recording after 60s
          const timeout = setTimeout(() => {
            if (this.forceStopRecording) {
              this.forceStopRecording();
            }
          }, this.state.maxTimeRecorder); // 60s

          // start countdown for recording max time
          this.setState({
            recordingSecondsRemaining: this.state.maxTimeRecorder / 1000,
          });

          this.recordingInterval = setInterval(() => {
            this.setState((prev) => {
              if (prev.recordingSecondsRemaining <= 1) {
                clearInterval(this.recordingInterval);
                return { recordingSecondsRemaining: 0 };
              }
              return {
                recordingSecondsRemaining: prev.recordingSecondsRemaining - 1,
              };
            });
          }, 1000);

          return { countdown: 0, showStop: true, recordingTimeout: timeout };
        }

        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };

  onConfirm = async (mediaBlobUrl) => {
    clearInterval(this.countdownInterval);
    clearTimeout(this.state.recordingTimeout);
    clearInterval(this.recordingInterval);

    this.setState({ showStop: false, recordingTimeout: null });

    try {
      const response = await fetch(mediaBlobUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;

        const { idQuestion, idQuiz, answers } = this.props;

        let data = {
          idAnswer: answers.id,
          idQuestion: idQuestion,
          label: idQuestion + "recordanswer.wav",
          wav: base64data,
        };

        localStorage.setItem(
          `quiz-${idQuiz}-${idQuestion}`,
          JSON.stringify([data])
        );

        // Impedisci future registrazioni mostrando solo il player
        this.setState({ savedRecording: base64data });
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Errore nel salvataggio dell'audio:", error);
    }

    this.resetRecording();
  };

  render() {
    const { savedRecording } = this.state;

    // if there is a saved recording, show it and disable other recording
    if (savedRecording || !this.props.isEmptyLabel) {
      return (
        <div>
          <audio className="m-2 w-100" src={savedRecording} controls />
          <p>
            {this.props.isEmptyLabel
              ? i18n.t("quiz.confirmedRecorder")
              : ''}
          </p>
        </div>
      );
    }

    return (
      <>
        <ReactMediaRecorder
          key={this.state.recorderKey}
          audio
          onStart={this.startCountdown}
          render={({ status, startRecording, stopRecording, mediaBlobUrl }) => {
            this.forceStopRecording = stopRecording;

            return (
              <div>
                {!mediaBlobUrl && status !== "recording" ? (
                  <Button className="primary bg-dark" onClick={startRecording}>
                    <FaMicrophoneAlt className="mr-2" />{" "}
                    {i18n.t("quiz.startRec")}
                  </Button>
                ) : null}

                {status === "recording" && (
                  <>
                    {!this.state.showStop ? (
                      <p className="bold">
                        {i18n.t("quiz.startSpeakingIn", {
                          countdown: this.state.countdown,
                        })}
                      </p>
                    ) : (
                      <>
                        <Button
                          className="primary bg-danger"
                          onClick={stopRecording}
                        >
                          <FaStop className="mr-2" /> {i18n.t("quiz.stopRec")}
                        </Button>
                        <p>
                          <small className="pulseText bold">
                            {i18n.t("quiz.recording")}
                            {this.state.recordingSecondsRemaining !== null &&
                              ` (${this.state.recordingSecondsRemaining}s)`}
                          </small>
                        </p>
                      </>
                    )}
                  </>
                )}

                <div className="my-3">
                  {mediaBlobUrl && (
                    <>
                      <div>
                        <audio
                          className="m-2 w-100"
                          src={mediaBlobUrl}
                          controls
                        />
                      </div>
                      <div>
                        <Button
                          className="m-2"
                          onClick={this.resetRecording}
                          color="primary bg-warning"
                        >
                          <FaRedo className="mr-2" />
                          {i18n.t("quiz.tryAgain")}/{i18n.t("quiz.reset")}
                        </Button>

                        <Button
                          className="m-2"
                          color="primary bg-success"
                          onClick={() => this.onConfirm(mediaBlobUrl)}
                        >
                          <FaCheckCircle className="mr-2" />
                          conferma registrazione
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          }}
        />
      </>
    );
  }
}
